import {
  CHAT,
  CHAT_ID,
  HOME,
  LOGIN,
  PATIENT_LIST,
  PATIENT_HEALTH_DATA,
  PATIENT_HEALTH_DATA_DETAIL,
  PROFILE,
  XRAY_PROCESS,
  ADD_PATIENT,
  MEDICAL_INFO,
  PROFESSIONALS,
  ADD_PROFESSIONALS,
  FORGOT_PASSWORD,
  FAQ,
  EDIT_PROFESSIONALS,
  ESTABLISHMENTS,
  EDIT_ESTABLISHMENT,
  ADD_ESTABLISHMENT,
  RECOVERY,
  LEGAL_INFORMATION,
  MEDICAL_EVENTS,
  EDIT_MEDICAL_EVENT,
  ADD_MEDICAL_EVENT,
  USER_MANUAL,
  XRAY_MANUAL,
  CXRAY_ANALYSIS,
  ECG_ANALYSIS,
  SYMPTOM_TRACKING,
  DIAGNOSTICS_DETAIL,
  DIAGNOSTICS_PRINT
} from './CONSTANTS'
import HomePage from 'pages/Home'
import LoginPage from 'pages/Login'
import { Routes, Route } from 'react-router-dom'
import HealthDataPage from 'pages/Patient/HealthData'
import HealthDataDetailPage from 'pages/Patient/HealthDataDetail'
import ProfilePage from 'pages/Profile'
import PatientsPage from 'pages/Patient'
import AddPatientPage from 'pages/Patient/AddPatient'
import ChatPage from 'pages/Chat'
import ChatInitialPage from 'pages/Chat/Initial'
import MessagePage from 'pages/Chat/Message'
import HealthDataInitialPage from 'pages/Patient/HealthData/initial'
import MedicalFormPage from 'pages/Patient/MedicalForm'
import NewProfessionalPage from 'pages/Professionals/AddProfessionals'
import Professional from 'pages/Professionals'
import ForgotPasswordPage from 'pages/ForgotPassword'
import RestrictedToEstablishment, {
  RestrictedToEstablishmentWithPermission
} from 'components/RestrictedToEstablishment'
import { FAQPage } from 'pages/FAQ'
import { PrivateRoute } from './components'
import ClinicalTrialProvider from 'services/context/clinicalTrial'
import EstablishmentPage from 'pages/Establishments'
import EstablishmentActionPage from 'pages/Establishments/Actions'
import RecoveryPage from 'pages/Recovery'
import LegalInformationPage from 'pages/LegalInformation'
import MedicalEventsPage from 'pages/MedicalEvents'
import MedicalEventActionPage from 'pages/MedicalEvents/Actions'
import PatientMedicalEventsPage from 'pages/PatientMedicalEvents'
import PatientMedicalEventActionPage from 'pages/PatientMedicalEvents/Actions'
import SymptomsTrackingPage from 'pages/Patient/SymptomsTracking'
import UserManual from 'pages/UserManual'
import XRayManual from 'pages/XRayManual'
import XrayManualGate from 'components/XrayManualGate'
import CxrayListPage from 'pages/Diagnostics/Cxray'
import EcgListPage from 'pages/Diagnostics/Ecg'
import DiagnosticDetailPage from 'pages/Diagnostics/Details'
import PrintView from 'pages/Diagnostics/Details/PrintView'
import { UploadDiagnosticsPage } from 'pages/Diagnostics/Upload'
import { IModulePermissionType } from 'types/establishment/types'
import { IProssionalRoleTypeEnum } from 'types/user/enum'

const patientMonitoringModule: IModulePermissionType[] = ['patient_monitoring']
const cxrayModule: IModulePermissionType[] = ['cxray_analysis']
const ecgModule: IModulePermissionType[] = ['ecg_analysis']
const chatModule: IModulePermissionType[] = ['chat']

/**
 * AppRoutes component defines the main application routes.
 * It includes public routes like login and forgot password,
 * and private routes that require authentication.
 * @returns JSX.Element
 */
const AppRoutes = () => {
  return (
    <Routes>
      <Route path={LOGIN} element={<LoginPage />} />
      <Route path={FORGOT_PASSWORD} element={<ForgotPasswordPage />} />
      <Route path={RECOVERY} element={<RecoveryPage />} />
      <Route path={USER_MANUAL} element={<UserManual />} />
      <Route path={XRAY_MANUAL} element={<XRayManual />} />
      <Route path={DIAGNOSTICS_PRINT()} element={<PrintView />} />
      <Route element={<PrivateRoute />} errorElement={<div>Error</div>}>
        <Route path={HOME} element={<HomePage />} />
        <Route path={ESTABLISHMENTS} element={<EstablishmentPage />} />
        <Route path={ADD_ESTABLISHMENT} element={<EstablishmentActionPage />} />
        <Route
          path={EDIT_ESTABLISHMENT()}
          element={<EstablishmentActionPage />}
        />
        <Route path={MEDICAL_EVENTS} element={<MedicalEventsPage />} />
        <Route path={ADD_MEDICAL_EVENT} element={<MedicalEventActionPage />} />
        <Route
          path={EDIT_MEDICAL_EVENT()}
          element={<MedicalEventActionPage />}
        />
        <Route
          path={PATIENT_LIST}
          element={
            <RestrictedToEstablishmentWithPermission
              modulesRequired={patientMonitoringModule}
            >
              <RestrictedToEstablishment />
            </RestrictedToEstablishmentWithPermission>
          }
        >
          <Route path='' element={<PatientsPage />} />
        </Route>
        <Route
          path={ADD_PATIENT}
          element={
            <RestrictedToEstablishmentWithPermission
              modulesRequired={patientMonitoringModule}
            >
              <RestrictedToEstablishment />
            </RestrictedToEstablishmentWithPermission>
          }
        >
          <Route path='' element={<AddPatientPage />} />
        </Route>
        <Route
          path={PATIENT_HEALTH_DATA()}
          element={
            <RestrictedToEstablishmentWithPermission
              modulesRequired={patientMonitoringModule}
            >
              <RestrictedToEstablishment />
            </RestrictedToEstablishmentWithPermission>
          }
        >
          <Route
            path=''
            element={
              <ClinicalTrialProvider>
                <HealthDataPage />
              </ClinicalTrialProvider>
            }
          >
            <Route path='' element={<HealthDataInitialPage />} />
            <Route path={MEDICAL_INFO} element={<MedicalFormPage />} />
            <Route
              path={MEDICAL_EVENTS}
              element={<PatientMedicalEventsPage />}
            />
            <Route
              path={ADD_MEDICAL_EVENT}
              element={<PatientMedicalEventActionPage />}
            />
            <Route
              path={EDIT_MEDICAL_EVENT()}
              element={<PatientMedicalEventActionPage />}
            />
            <Route path={SYMPTOM_TRACKING} element={<SymptomsTrackingPage />} />
          </Route>
        </Route>
        <Route
          path={PATIENT_HEALTH_DATA_DETAIL()}
          element={
            <RestrictedToEstablishmentWithPermission
              modulesRequired={patientMonitoringModule}
            >
              <RestrictedToEstablishment />
            </RestrictedToEstablishmentWithPermission>
          }
        >
          <Route path='' element={<HealthDataDetailPage />} />
        </Route>
        <Route path={PROFILE} element={<ProfilePage />} />

        <Route
          path={CHAT}
          element={
            <RestrictedToEstablishmentWithPermission
              modulesRequired={chatModule}
              withOutlet
            />
          }
        >
          <Route path={''} element={<ChatPage />}>
            <Route path='' element={<ChatInitialPage />} />
            <Route path={CHAT_ID()} element={<MessagePage />} />
          </Route>
        </Route>
        <Route
          path={PROFESSIONALS}
          element={
            <RestrictedToEstablishment
              rolesAllowed={[IProssionalRoleTypeEnum.administrator]}
            />
          }
        >
          <Route path='' element={<Professional />} />
        </Route>

        <Route
          path={ADD_PROFESSIONALS}
          element={
            <RestrictedToEstablishment
              rolesAllowed={[IProssionalRoleTypeEnum.administrator]}
            />
          }
        >
          <Route path='' element={<NewProfessionalPage />} />
        </Route>

        <Route
          path={EDIT_PROFESSIONALS()}
          element={
            <RestrictedToEstablishment
              rolesAllowed={[IProssionalRoleTypeEnum.administrator]}
            />
          }
        >
          <Route path='' element={<NewProfessionalPage />} />
        </Route>
        <Route path={FAQ} element={<FAQPage />} />
        <Route path={LEGAL_INFORMATION} element={<LegalInformationPage />} />
        <Route
          path={CXRAY_ANALYSIS}
          element={
            <RestrictedToEstablishmentWithPermission
              modulesRequired={cxrayModule}
            >
              <XrayManualGate />
            </RestrictedToEstablishmentWithPermission>
          }
        >
          <Route path='' element={<CxrayListPage />} />
          <Route
            path='upload'
            element={<UploadDiagnosticsPage initialExamType='xray' />}
          />
          <Route
            path={DIAGNOSTICS_DETAIL()}
            element={<DiagnosticDetailPage />}
          />
        </Route>
        <Route
          path={ECG_ANALYSIS}
          element={
            <RestrictedToEstablishmentWithPermission
              modulesRequired={ecgModule}
              withOutlet
            />
          }
        >
          <Route path='' element={<EcgListPage />} />
          <Route
            path='upload'
            element={<UploadDiagnosticsPage initialExamType='ecg' />}
          />
          <Route
            path={DIAGNOSTICS_DETAIL()}
            element={<DiagnosticDetailPage />}
          />
        </Route>
      </Route>
    </Routes>
  )
}

export default AppRoutes
